export default __webpack_public_path__ + "static/media/place-order.a98b2337.png";